import { FC } from 'react'

import LogoWiggotBlack from '@/assets/icons/components/IconLogoWiggotBlack'
import LogoWiggotBlue from '@/assets/icons/components/IconLogoWiggotBlue'
import LogoWiggotWhite from '@/assets/icons/components/IconLogoWiggotWhite'

export interface LogoWiggotProps {
  variant: 'white' | 'black' | 'blue'
  width?: string
  height?: string
}

export const LogoWiggot: FC<LogoWiggotProps> = ({
  variant,
  height = 'auto',
  width = 'auto'
}) => {
  if (variant === 'black') {
    return <LogoWiggotBlack width={width} height={height} />
  }

  if (variant === 'blue') {
    return <LogoWiggotBlue width={width} height={height} />
  }

  return <LogoWiggotWhite width={width} height={height} />
}

export default LogoWiggot
